import { Typography } from "@mui/material";
import { Company } from "../../../setups/types/setupTypes";
import { Employee } from "../../types/processTypes";
import { LabelTemplate } from "../styles/table";
import InterTemplate from "../InterTemplate";
import BasicTemplate from "../BasicTemplate";
import OxagonTwoTemplate from "../OxagonTwoTemplate";
import MaledaTemplate from "../MaledaTemplate";
import BasicTwoTemplate from "../BasicTwoTemplate";
import BasicThreeTemplate from "../BasicThreeTemplate";
import EntranceTemplate from "../EntranceTemplate";
import AkeemTemplate from "../AkeemTemplate";
import CadresTemplate from "../CadresTemplate";
import SkillStarTemplate from "../SkillStarTemplate";
import SanadTemplate from "../SanadTemplate";
import WaadaTemplate from "../WaadaTemplate";
import JewelTemplate from "../JewelTemplate";
import HaloolTemplate from "../HaloolTemplate";
import GoldenTemplate from "../GoldenTemplate";
import BasicTemplateTwo from "../BasicTemplateTwo";
import BasicTemplateMermaid from "../BasicTemplateMermaid";
import MotaTemplate from "../MotaTemplate";
import HomeTemplate from "../HomeTemplate";
import MutaTemplate from "../MutaTemplate";
import QadisiyaTemplate from "../QadisiyaTemplate";

export interface CvTemplateRendererProps {
  employee: Employee;
  company: Company;
  cvTemplate: LabelTemplate;
  backgroundColor: string;
}

export function CvTemplateRenderer({
  employee,
  company,
  cvTemplate,
  backgroundColor,
}: CvTemplateRendererProps) {
  const props = {
    backgroundColor,
    cvTemplate,
    currentEmployee: employee,
    selectedCompany: company,
  };

  switch (cvTemplate.name) {
    case "basic":
      return <BasicTemplate {...props} />;
    case "basic2":
      return <BasicTemplateTwo {...props} />;
    case "inaya":
      return <BasicTwoTemplate {...props} />;
    case "mermaid":
      return <BasicTemplateMermaid {...props} />;
    case "basic3":
      return <BasicThreeTemplate {...props} />;
    case "entrance":
      return <EntranceTemplate {...props} />;
    case "akeem":
      return <AkeemTemplate {...props} />;
    case "cadres":
      return <CadresTemplate {...props} />;
    case "oxagon":
      return <OxagonTwoTemplate {...props} />;
    case "maleda":
      return <MaledaTemplate {...props} />;
    case "mota":
      return <MotaTemplate {...props} />;
    case "home":
      return <HomeTemplate {...props} />;
    case "muta":
      return <MutaTemplate {...props} />;
    case "qadisiya":
      return <QadisiyaTemplate {...props} />;
    case "stars":
      return <SkillStarTemplate {...props} />;
    case "sanad":
      return <SanadTemplate {...props} office="alamri" />;
    case "waada":
      return <SanadTemplate {...props} office="waada" />;
    case "waada2":
      return <WaadaTemplate {...props} office="waada" />;
    case "alamri2":
      return <WaadaTemplate {...props} office="alamri" />;
    case "almansa2":
      return <WaadaTemplate {...props} office="almansa" />;
    case "almansa":
      return <SanadTemplate {...props} office="almansa" />;
    case "jewel":
      return <JewelTemplate {...props} />;
    case "halool":
      return <HaloolTemplate {...props} />;
    case "golden":
      return <GoldenTemplate {...props} />;
    default:
      return <InterTemplate {...props} />;
  }
}

export function CvTemplateRendererOrEmpty(props: CvTemplateRendererProps) {
  if (!props.company.cvTemplate) {
    return <Typography variant="h6">No Template Found</Typography>;
  }
  return <CvTemplateRenderer {...props} />;
}
